export var mergeSx = function () {
    var sxs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sxs[_i] = arguments[_i];
    }
    return sxs
        .map(function (sx) {
        if (!sx) {
            return [];
        }
        return Array.isArray(sx) ? sx : [sx];
    })
        .flat();
};
